




import { Component, Vue } from 'vue-property-decorator'
import ListaDeNovidades from '@/components/novidades/ListaDeNovidades.vue'

@Component({ components: { ListaDeNovidades } })
export default class TelaDeNovidades extends Vue {}
